import {
  AfterViewInit,
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  Renderer2,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[accredibleShowMore]',
})
export class ShowMoreDirective implements AfterViewInit {
  private readonly _el = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);

  text = input.required<string>({ alias: 'accredibleShowMore' });
  maxLength = input<number>(100);
  readMore = input<string>('read more');
  readLess = input<string>('read less');

  private _isExpanded = false;
  private _textSpan!: HTMLElement;
  private _toggleLink!: HTMLElement;

  constructor() {
    effect(() => {
      const fullText = this.text();
      const maxLen = this.maxLength();

      if (this._textSpan) {
        this._updateContent(fullText, maxLen);
      }
    });
  }

  ngAfterViewInit(): void {
    this._renderer.setProperty(this._el.nativeElement, 'textContent', '');

    this._textSpan = this._renderer.createElement('span');
    this._renderer.appendChild(this._el.nativeElement, this._textSpan);

    this._toggleLink = this._renderer.createElement('a');
    this._renderer.setStyle(this._toggleLink, 'color', 'var(--color-natural-180)');
    this._renderer.setStyle(this._toggleLink, 'cursor', 'pointer');
    this._renderer.listen(this._toggleLink, 'click', (event) => this._toggle(event));
    this._renderer.appendChild(this._el.nativeElement, this._toggleLink);

    this._updateContent(this.text(), this.maxLength());
  }

  private _updateContent(fullText: string, maxLen: number): void {
    this._isExpanded = false;

    if (fullText.length <= maxLen) {
      this._renderer.setProperty(this._textSpan, 'innerHTML', fullText);
      this._renderer.setStyle(this._toggleLink, 'display', 'none');
    } else {
      const truncated = fullText.slice(0, maxLen) + '...';
      this._renderer.setProperty(this._textSpan, 'innerHTML', truncated);
      this._renderer.setProperty(this._toggleLink, 'textContent', ` ${this.readMore()}`);
      this._renderer.setStyle(this._toggleLink, 'display', 'inline');
    }
  }

  private _toggle(event: Event): void {
    event.preventDefault();
    this._isExpanded = !this._isExpanded;

    const fullText = this.text();
    const truncated = fullText.slice(0, this.maxLength()) + '...';

    this._renderer.setProperty(
      this._textSpan,
      'innerHTML',
      this._isExpanded ? fullText : truncated,
    );
    this._renderer.setProperty(
      this._toggleLink,
      'textContent',
      this._isExpanded ? ` ${this.readLess()}` : ` ${this.readMore()}`,
    );
  }
}
